import {
  ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_VIEW,
  ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_EDIT,
  ROUTE_2BAP_EXTERNAL_EDIT_ENTITY_PREFIX,
  ROUTE_2BAP_EXTERNAL_PROFILE_CLASS_EDIT,
  ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_EDIT,
  ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_PROFILE,
  ROUTE_2BAP_EXTERNAL_PROFILE_MODULE_AUTH_ERROR
} from 'constants/routePath';

export class ProfilesRouterHelper {
  
  static SUMMARY_VIEW_PATH = ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_VIEW;
  
  static SUMMARY_EDIT_PATH = ROUTE_2BAP_EXTERNAL_PROFILE_SUMMARY_EDIT;
  
  static CLASS_ID = 'classId';
  static CLASS_EDIT_PATH =
    `${ROUTE_2BAP_EXTERNAL_EDIT_ENTITY_PREFIX}/${ROUTE_2BAP_EXTERNAL_PROFILE_CLASS_EDIT}(/:${ProfilesRouterHelper.CLASS_ID})`;
  
  static LEARNER_ID = 'learnerId';
  static LEARNER_EDIT_PATH =
    `${ProfilesRouterHelper.CLASS_EDIT_PATH}/${ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_EDIT}(/:${ProfilesRouterHelper.LEARNER_ID})`;
  
  static LEARNER_PROFILE_PATH = `${ROUTE_2BAP_EXTERNAL_PROFILE_LEARNER_PROFILE}/:${ProfilesRouterHelper.LEARNER_ID}`;
  
  static AUTH_ERROR_PATH = ROUTE_2BAP_EXTERNAL_PROFILE_MODULE_AUTH_ERROR;
  
}
